import React from "react";

import { MultipleAutocompleteChip } from "@/components/forms/MultipleAutocompleteChip";
import {
  CompanySummary,
  useAllCompaniesQuery,
} from "@/pages/banners/remote-apis/bannerUsersApi";

export const CompaniesSelector = ({
  value = [],
  onChange = () => {},
}: {
  value: CompanySummary[];
  onChange: (value: CompanySummary[]) => void;
}) => {
  const { data: allCompanies = [], isLoading } = useAllCompaniesQuery();

  return (
    <MultipleAutocompleteChip
      value={value}
      onChange={onChange}
      options={allCompanies}
      isLoading={isLoading}
    />
  );
};
